export default "__VITE_ASSET__114b7598__"